import { jsxs, jsx } from "react/jsx-runtime";
import { ResponsiveContainer } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/ResponsiveContainer.js";
import { BarChart } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/chart/BarChart.js";
import { CartesianGrid } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/CartesianGrid.js";
import { XAxis } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/YAxis.js";
import { Tooltip } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/Tooltip.js";
import { Legend } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/Legend.js";
import { Bar } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/Bar.js";
function DifficultyBarChart({ data }) {
  const chartData = data.map((d) => ({
    name: `Lv.${d.difficultyLevel}`,
    "Pre-AIQ": Math.round(d.preAccuracy * 100),
    "Post-AIQ": Math.round(d.postAccuracy * 100),
    questions: d.totalQuestions
  }));
  if (chartData.length === 0) {
    return /* @__PURE__ */ jsxs("div", { className: "p-6 bg-white rounded-xl shadow-2xs border border-gray-100", children: [
      /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-4", children: "난이도별 정답률 비교" }),
      /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-500 text-center py-8", children: "데이터가 없습니다" })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "p-6 bg-white rounded-xl shadow-2xs border border-gray-100", children: [
    /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-4", children: "난이도별 정답률 비교" }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height: 300, children: /* @__PURE__ */ jsxs(BarChart, { data: chartData, barGap: 4, children: [
      /* @__PURE__ */ jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }),
      /* @__PURE__ */ jsx(XAxis, { dataKey: "name", tick: { fontSize: 13 } }),
      /* @__PURE__ */ jsx(YAxis, { domain: [0, 100], tick: { fontSize: 12 }, tickFormatter: (v) => `${v}%` }),
      /* @__PURE__ */ jsx(
        Tooltip,
        {
          formatter: (value, name) => [`${value}%`, name],
          labelFormatter: (label) => {
            var _a;
            return `${label} (${((_a = chartData.find((d) => d.name === label)) == null ? void 0 : _a.questions) || 0}문제)`;
          }
        }
      ),
      /* @__PURE__ */ jsx(Legend, { wrapperStyle: { fontSize: 13 } }),
      /* @__PURE__ */ jsx(Bar, { dataKey: "Pre-AIQ", fill: "#3b82f6", radius: [4, 4, 0, 0] }),
      /* @__PURE__ */ jsx(Bar, { dataKey: "Post-AIQ", fill: "#8b5cf6", radius: [4, 4, 0, 0] })
    ] }) })
  ] });
}
export {
  DifficultyBarChart
};
//# sourceMappingURL=DifficultyBarChart.js.map
